module.exports = __webpack_public_path__ + "static/media/visa.46d89241.png";